const GUEST_NAME_KEY = "pizza_guest_display_name";

export const getGuestDisplayName = () => {
  try {
    return localStorage.getItem(GUEST_NAME_KEY)?.trim() || "";
  } catch {
    return "";
  }
};

export const setGuestDisplayName = (name) => {
  try {
    const v = (name || "").toString().trim();
    if (v) {
      localStorage.setItem(GUEST_NAME_KEY, v);
    } else {
      localStorage.removeItem(GUEST_NAME_KEY);
    }
  } catch {
    /* ignore */
  }
};
